export default [
    {
        _name: 'CSidebarNav',
        _children: [
            // {
            //     _name: 'CSidebarNavItem',
            //     name: 'Dashboard',
            //     to: '/admin/dashboard',
            // },
            // {
            //     _name: 'CSidebarNavDropdown',
            //     name: 'Role Mangement',
            //     items: [
            //         {
            //             name: 'All User',
            //             to: '/role-management/all-user'
            //         },
            //         {
            //             name: 'Verify Citizen ID',
            //             to: '/role-management/verify-citizen-id'
            //         }
            //     ]
            // },
            // {
            //     _name: 'CSidebarNavDropdown',
            //     name: 'Home Page Management',
            //     items: [
            //         {
            //             name: 'Banner',
            //             to: '/home-page-management/banner'
            //         },
            //         // {
            //         //     name: 'Popular Course',
            //         //     to: '/home-page-management/popular-course'
            //         // },
            //         // {
            //         //     name: 'New Course',
            //         //     to: '/home-page-management/new-course'
            //         // }
            //     ]
            // },
            {
                _name: 'CSidebarNavDropdown',
                name: 'Course Management',
                items: [
                    {
                        name: 'Course Record Overview',
                        to: '/course-management/courses-overview'
                    },
                    // {
                    //     name: 'Examination',
                    //     to: '/course-management/examination'
                    // }
                ]
            },
            // {
            //     _name: 'CSidebarNavItem',
            //     name: 'Report And Export',
            //     to: '/report-and-export'
            // },
            // {
            //     _name: 'CSidebarNavDropdown',
            //     name: 'Achievement',
            //     items: [
            //         {
            //             name: 'Certificate Management',
            //             to: '/achievement/certificate-management'
            //         }
            //     ]
            // }
        ]
    }
]